<template>
  <div id="payment" class="gray-gradient">
    <navbar :data="2"/>
    <intro/>
    <popular-bundles/>
    <random-offers/>
    <MtnApps/>
    <special-services/>
    <Footer/>
  </div>
</template>

<script>
import Navbar from '../Navbar'
import Intro from '../Intro'
import PopularBundles from '../PopularBundles'
import RandomOffers from '../RandomOffers'
import MtnApps from '../MtnApps'
import SpecialServices from '../SpecialServices'
import Footer from '../../components/core/Footer'
export default {
  name: 'Payment',
  components: { Footer, SpecialServices, MtnApps, RandomOffers, PopularBundles, Intro, Navbar },
  data () {
    return {
    }
  },
  created () {
    this.$store.state.activeNav = 2
  },
  mounted () {
  },
  methods: {
  }
}
</script>
<style lang="scss">
@import "src/assets/sass/main";
</style>
